import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { SupplierDetailComponent } from './views/settings/suppliers/supplier-detail/supplier-detail.component';
import { MySupplierDetailComponent } from './views/settings/buyers/my-suppliers/my-supplier-detail/my-supplier-detail.component'
//import { AdminDashboardComponent } from './views/dashboard/admin/admin-dashboard/admin-dashboard.component';

import { AppComponent } from './app.component';
import { TokenLoginComponent } from './views/tokenBasedScreens/tokenLogin/tokenLogin-component';
import { RfqTokenDetailsComponent } from './views/tokenBasedScreens/rfqDetails/rfqDetails.component';
import { RfqTokenQuoteLineItemsComponent } from './views/tokenBasedScreens/quote-line-items/quote-line-items.component';
import { RfqTokenQuoteFormHeaderComponent } from './views/tokenBasedScreens/quote-form-header/quote-form-header.component';
import { RfqTokenQuotePaymentTermsComponent } from './views/tokenBasedScreens/quote-payment-terms/quote-payment-terms.component';
import { RfqTokenQuoteFormPreviewComponent } from './views/tokenBasedScreens/quote-preview/quote-form-preview.component';
export const rootRouterConfig: Routes = [
  // // Public short URL that redirects to the existing operations token-login route
  // { path: 'token-login', redirectTo: '/operations/token-login', pathMatch: 'full' ,data: { title: 'VS-MPS | Token Login', breadcrumb: 'Settings' }},
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "supplier-detail",
        component: SupplierDetailComponent,
        outlet: "form-outlet",
        canActivate: [AuthGuard],
      },
      {
        path: 'buyer-data-management',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/buyer-data-Management/buyer-data-Management.module').then(m => m.BuyerDataManagementModule),
        data: { title: 'Buyer Data Management', breadcrumb: 'buyer-data-management' }
      },
      {
        path: 'notifications-list',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule),
        data: { title: 'Notifications', breadcrumb: 'notifications' }
      },
      {
        path: "my-supplier-detail",
        component: MySupplierDetailComponent,
        outlet: "form-outlet",
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'DASHBOARD' }
      },
      {
        path: 'supplier',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/supplier/supplier.module').then(m => m.SupplierModule),
        data: { title: 'Supplier', breadcrumb: 'SUPPLIER' }
      },
      {
        path: 'search',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/search/search.module').then(m => m.SearchModule),
        data: { title: 'Search', breadcrumb: 'Search' }
      },
      {
        path: 'environmental',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/environmental/environmental.module').then(m => m.EnvironmentalModule),
        data: { title: 'Environmental', breadcrumb: 'environmental' }
      },
      {
        path: 'social',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/social/social.module').then(m => m.socialDashboardModule),
        data: { title: 'Social', breadcrumb: 'social' }
      },
      {
        path: 'administration',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/administration/administration.module').then(m => m.AdministrationModule),
        data: { title: 'Administration', breadcrumb: 'administration' }
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'dataManagement',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/data-management.module').then(m => m.DataManagementModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'buyer-data-management',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/buyer-data-Management/buyer-data-Management.module').then(m => m.BuyerDataManagementModule),
        data: { title: 'Buyer Data Management', breadcrumb: 'buyer-data-management' }
      },
      {
        path: 'dashboard/admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/admin/admin.module').then(m => m.AdminModule),
        data: { title: 'dashboard', breadcrumb: 'dashboard' }
      },
      {
        path: 'operations',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/operations/operations.module').then(m => m.OperationsModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'userManagement',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/userManagement/userManagement.module').then(m => m.UserManagementModule),
        data: { title: 'userManagement', breadcrumb: 'userManagement' }
      },
    ]
  },
  {
    path: '',
    component: AppComponent,
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule),
        data: { title: 'Session' }
      },
      {
        path: 'tokenLogin',
        component: TokenLoginComponent,
        data: { title: 'Token Login' }
      },
      {
        path: 'rfqToken/rfqDetails/:rfqId',
        component: RfqTokenDetailsComponent,
        data: { title: 'RFQ Token Details' }
      },
      {
        path: 'rfqToken/quote-line-items',
        component: RfqTokenQuoteLineItemsComponent,
        data: { title: 'RFQ Token Quote Line Items' }
      },
      {
        path: 'rfqToken/quote-header-details',
        component: RfqTokenQuoteFormHeaderComponent,
        data: { title: 'RFQ Token Quote Header' }
      },
      {
        path: 'rfqToken/quote-payment-terms',
        component: RfqTokenQuotePaymentTermsComponent,
        data: { title: 'RFQ Token Quote Payment Terms' }
      },
      {
        path: 'rfqToken/quote-preview',
        component: RfqTokenQuoteFormPreviewComponent,
        data: { title: 'RFQ Token Quote Preview' }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'Dashboard' }
      },
      {
        path: 'emissions',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/environmental/emissions/emissions.module').then(m => m.EmissionsModule),
        data: { title: 'Emissions', breadcrumb: 'Emissions' }
      },
      {
        path: 'administration',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/administration/administration.module').then(m => m.AdministrationModule),
        data: { title: 'Administration', breadcrumb: 'Administration' }
      },
      {
        path: 'social-dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/social/social-dashboard/social-dashboard.module').then(m => m.socialDashboardModule),
        data: { title: 'social-dashboard', breadcrumb: 'social-dashboard' }
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'dataManagement',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/data-management.module').then(m => m.DataManagementModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },

      {
        path: 'dashboard/admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/admin/admin.module').then(m => m.AdminModule),
        data: { title: 'dashboard', breadcrumb: 'dashboard' }
      },
      //{ path: '', redirectTo: 'dashboard/admin', pathMatch: 'full' },  // Default route
      //{ path: 'dashboard/admin', loadChildren: () => import('./views/dashboard/admin/admin.module').then(m => m.AdminModule) },
    ]
  },
  {
    path: 'overview',
    redirectTo: '/auth/signin',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'sessions/404'
  }
];

